import React from 'react';

const STATUS_CONFIG = {
  READY:       { bg: 'var(--color-bg-active)',      color: 'var(--color-text-muted)' },
  IN_PROGRESS: { bg: 'var(--color-indigo-light)',   color: 'var(--color-indigo-dark)' },
  CLOSED:      { bg: 'var(--color-success-light)',  color: 'var(--color-success-dark)' },
};

export default function ScrapProjectStatusBadge({ status }) {
  if (!status) return null;
  const key = status.toUpperCase();
  const cfg = STATUS_CONFIG[key] || STATUS_CONFIG.READY;
  const label = key.split('_').map(w => w.charAt(0) + w.slice(1).toLowerCase()).join(' ');
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: 'var(--space-1) var(--space-4)',
      borderRadius: 'var(--radius-pill)',
      fontSize: 'var(--text-2xs)', fontWeight: 'var(--font-semibold)',
      whiteSpace: 'nowrap', lineHeight: '1.4',
      background: cfg.bg, color: cfg.color,
    }}>
      {label}
    </span>
  );
}
